import { toFarsiNumber } from "../cudtom-hooks/en-to-persian";
import { useContext } from "react";
import { MyContext } from "../context/myContext";
import Loading from "./Loading";
import { useSelector } from "react-redux";
import {
  selectCurrentPage,
  selectIsPending,
} from "../features/common-states/commonStatesSlice";
import { selectRequestStyles } from "../features/request/requestSlice";

const UserInformationTable = () => {
  const page = useSelector(selectCurrentPage);
  const { headArray, bodyArray, searchedBodyArray } = useContext(MyContext);
  const data = searchedBodyArray?.length > 0 ? searchedBodyArray : bodyArray; //searchedBodyArray comes from UserManagement
  const isPending = useSelector(selectIsPending);
  const statusStyle = useSelector(selectRequestStyles);
  return (
    <div dir="rtl" className="overflow-auto w-full">
      <table
        dir="ltr"
        className="border border-gray-300 whitespace-nowrap w-full"
      >
        <thead>
          <tr>
            {headArray.map((item, index) => {
              return (
                <th
                  key={index}
                  className="border border-gray-300 whitespace-nowrap bg-gray-600 text-white p-3 font-light text-xs select-none"
                >
                  {item}
                </th>
              );
            })}
          </tr>
        </thead>
        {isPending ? (
          <tbody>
            <tr>
              <td colSpan="100" className="py-2">
                <Loading />
              </td>
            </tr>
          </tbody>
        ) : (
          <tbody>
            {data?.length === 0 || data[0] === "موردی یافت نشد" ? (
              <tr>
                <td
                  className="text-sm py-3 text-right pr-5 sm:text-center"
                  colSpan="100%"
                >
                  موردی یافت نشد
                </td>
              </tr>
            ) : (
              data?.map((item, index) => {
                return (
                  <tr
                    key={index}
                    className="border border-gray-300 whitespace-nowrap hover:!bg-whiteBg [&:nth-child(even)]:bg-gray-100 select-none text-[10px] sm:text-xs"
                  >
                    {item?.map((entry, index1) => {
                      return (
                        <td
                          key={index1}
                          className={`border border-gray-300 whitespace-nowrap py-3 px-1`}
                          style={index1 === 12 ? statusStyle[index] : {}}
                        >
                          {entry}
                        </td>
                      );
                    })}
                    <td>{toFarsiNumber((index + 1) + (page - 1) * 20) }</td>
                  </tr>
                );
              })
            )}
          </tbody>
        )}
      </table>
    </div>
  );
};

export default UserInformationTable;
